import { redirect } from 'redux-first-router';
import { useDispatch } from 'react-redux';
import DocumentHeader from '@components/DocumentHeader';
import ReportSection from '@components/ReportSection';
import ReportSubSection from '@components/ReportSubSection';
import { useTracking } from 'react-tracking';
import { UserSectionTitle } from '@components/User/styled';
import { CallToAction, Plan } from './styled';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { useEffect } from 'react';
import useUser from '@/hooks/useUser';
import { useUserPlans } from '@/hooks/useUserPlans';

const Subscription = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'manageSubscription',
  });
  const dispatch = useDispatch();
  const { name } = useUserPlans();
  const { data: userData } = useUser();
  const provider = userData.billing.provider;

  useEffect(() => {
    // Stripe subscribers can't access this page
    if (provider === 'stripe') {
      dispatch(redirect({ type: ROUTE_DASHBOARD }));
    } else {
      trackEvent({ action: 'landed' });
    }
  }, [dispatch, provider, trackEvent]);

  const manageSubscriptionHref =
    provider === 'apple'
      ? 'https://support.apple.com/en-au/guide/iphone/iph3dfd91de/ios'
      : 'https://play.google.com/store/account/subscriptions';
  return (
    <Track>
      <DocumentHeader title="Manage Subscription" />
      <UserSectionTitle data-cy-id="user-subscription-title">
        Manage Subscription
      </UserSectionTitle>
      <ReportSection>
        <ReportSubSection
          unOrdered
          title="Subscription"
          body={
            <>
              <p>
                You are currently subscribed to our{' '}
                <Plan>
                  {provider} {name} Plan
                </Plan>
                .
              </p>
              {(provider === 'apple' || provider === 'google') && (
                <p>
                  <span>Please visit </span>
                  <CallToAction
                    data-cy-id="manage-subscription-link"
                    href={manageSubscriptionHref}
                    rel="nofollow noreferrer"
                    target="_blank"
                    onClick={() =>
                      trackEvent({
                        action: 'click',
                        modifier: 'cta',
                        subject: provider,
                      })
                    }
                  >
                    {provider}
                  </CallToAction>
                  <span>
                    {' '}
                    and follow the instructions to manage your subscription.
                  </span>
                </p>
              )}
            </>
          }
        />
      </ReportSection>
    </Track>
  );
};

export default Subscription;
